export default "__VITE_ASSET__BuuerwEl__"